import React from 'react'
import { Box, CenteredBox } from './Box'

export const Hero = ({ red, children }) => (
  <CenteredBox
    container
    column
    fullWidth
    px={24}
    height={600}
    gap={48}
    mt={80}
    overflow="hidden"
  >
    <Box
      position="absolute"
      height={700}
      fullWidth
      top={0}
      overflow="hidden"
    >
      <Box
        position="absolute"
        fullWidth
        height={1023}
        background={red
          ? 'linear-gradient(180deg, #000 0%, #581E28 36.21%, var(--red) 68.68%, #CB072A 86.54%)'
          : 'linear-gradient(180deg, #000 0%, #0A0A57 36.21%, #00F 68.68%, #5555FC 86.54%)'}
        zIndex={-1}
      />
    </Box>
    {children}
  </CenteredBox>
)